/* Divine Hindu — swipeable product rows under the festive banners (homepage), the puja banners (Pujas page) and on product pages, Oct 2026.
   Keeps the small progress bar under each row in step with the swipe, and runs the desktop arrows
   ([data-dfb-nav="prev"|"next"]). Cart buttons in product rows are handled by assets/dh-divine-picks.js.
   Puja rows under homepage banners ([data-dfb-pujas], snippets/dh-festive-pujas.liquid) get their cards here when they
   come near the screen, from /collections/<handle>?view=dh-puja-row (templates/collection.dh-puja-row.liquid). */
(function () {
  if (window.__dfbRows) return;
  window.__dfbRows = true;
  function setup(rail) {
    if (rail.__dfb) { if (rail.__dfbUpd) rail.__dfbUpd(); return; }
    rail.__dfb = true;
    var row = rail.closest('.dfb-row') || rail.parentNode;
    var bar = row.querySelector('.dfb-row__bar'), th = bar && bar.querySelector('[data-dfb-thumb]');
    var prev = row.querySelector('[data-dfb-nav="prev"]'), next = row.querySelector('[data-dfb-nav="next"]');
    function upd() {
      var w = rail.scrollWidth, c = rail.clientWidth, max = w - c;
      var x = max > 0 ? Math.min(1, Math.max(0, rail.scrollLeft / max)) : 0;
      if (bar && th) {
        if (!c || max <= 4) { bar.hidden = true; }
        else {
          var r = c / w;
          bar.hidden = false;
          th.style.width = (r * 100) + '%';
          th.style.transform = 'translateX(' + (x * (1 / r - 1) * 100) + '%)';
        }
      }
      if (prev) prev.hidden = rail.scrollLeft <= 4;
      if (next) next.hidden = max <= 4 || rail.scrollLeft >= max - 4;
    }
    function go(dir) { rail.scrollBy({ left: dir * Math.max(160, rail.clientWidth * 0.9), behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    rail.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd, { passive: true });
    window.addEventListener('load', upd);
    rail.__dfbUpd = upd;
    upd();
  }
  function fillPujas(row) {
    if (row.__dfbp) return;
    row.__dfbp = true;
    var rail = row.querySelector('[data-dfb-rail]');
    var n = parseInt(row.getAttribute('data-n'), 10) || 12;
    fetch(row.getAttribute('data-dfb-pujas'), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var box = document.createElement('div');
        box.innerHTML = html || '';
        var cards = Array.prototype.slice.call(box.querySelectorAll('.dpc'), 0, n);
        if (!cards.length || !rail) { row.hidden = true; return; }
        Array.prototype.forEach.call(rail.querySelectorAll('.dfb-psk'), function (k) { k.parentNode.removeChild(k); });
        var end = rail.querySelector('.dfb-pc--all');
        cards.forEach(function (c) { rail.insertBefore(c, end); });
        if (end) end.hidden = false;
        row.classList.add('is-loaded');
        if (rail.__dfbUpd) rail.__dfbUpd(); else setup(rail);
      })
      .catch(function () { row.hidden = true; });
  }
  function pujaRows() {
    var rows = document.querySelectorAll('[data-dfb-pujas]');
    if (!rows.length) return;
    if (!('IntersectionObserver' in window)) { Array.prototype.forEach.call(rows, fillPujas); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); fillPujas(e.target); } });
    }, { rootMargin: '900px 0px' });
    Array.prototype.forEach.call(rows, function (r) { if (!r.__dfbp) io.observe(r); });
  }
  function all() { Array.prototype.forEach.call(document.querySelectorAll('[data-dfb-rail]'), setup); pujaRows(); }
  window.dfbRowsInit = all; /* rows filled after the page loads (sections/dh-pdp-rows.liquid) call this */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
